import React from "react";
import firebase from "../../firebase";
import { Editor } from "@tinymce/tinymce-react";
import {
  Item,
  Label,
  Header,
  Icon,
  Modal,
  Form,
  Button,
  Input,
  Grid,
  Segment,
  Container,
} from "semantic-ui-react";
import moment from "moment";
import Parser from "html-react-parser";
import BlogTypesInfo from "./BlogTypesInfo";
import { connect } from "react-redux";

let BLOG_ADD_SCORE = 10;

class Blogs extends React.Component {
  state = {
    user: this.props.currentUser,
    blogs: [],
    usersRef: firebase.database().ref("users"),
    contentModal: false,
    typeModal: false,
    blogType: "",
    blogName: "",
    blogDetails: "",
    blogDate: "",
    userContributions: 0,
  };

  componentDidMount() {
    this.addListeners();
  }

  componentWillUnmount() {
    this.removeListeners();
  }

  addListeners = () => {
    let loadedBlogs = [];
    this.state.usersRef
      .child(this.state.user.uid)
      .child("blogs")
      .on("child_added", (snap) => {
        let blog = snap.val();
        blog["uid"] = snap.key;
        loadedBlogs.unshift(blog);
        this.setState({ blogs: loadedBlogs });
      });

    loadedBlogs = [];
    this.state.usersRef
      .child(this.state.user.uid)
      .child("blogs")
      .on("child_removed", (snap) => {
        let keyToRemove = snap.key;
        loadedBlogs = this.state.blogs.filter((b) => b.uid !== keyToRemove);
        console.log("The child has been removed");
        console.log(loadedBlogs.length);
        this.setState({ blogs: loadedBlogs });
      });

    let currentContext = this;
    this.state.usersRef
      .child(this.state.user.uid)
      .child("contributions")
      .once("value")
      .then(function (snapshot) {
        let loadedContrib = snapshot.val(); // "ada"
        let userContributions = loadedContrib === null ? 0 : loadedContrib;
        currentContext.setState({ userContributions: userContributions });
      });
    this.state.usersRef
      .child(this.state.user.uid)
      .on("child_changed", (snap) => {
        let updatedValue = snap.val();
        if (!isNaN(updatedValue))
          this.setState({ userContributions: updatedValue });
      });

    // let loadedBlogs = [];
    // this.state.blogsRef.child(this.state.user.uid).on("child_changed", (snap) => {
    //   let updatedBlog = snap.val();
    //   let updatedBlogsList = [...this.state.blogs];
    //   let ind = updatedBlogsList.findIndex((art) => art.id === updatedBlog.id);
    //   updatedBlogsList[ind] = updatedBlog;
    //   this.setState({ blogs: updatedBlogsList });
    // console.log(snap.val())
    // });
  };

  removeListeners = () => {
    this.state.usersRef.child(`${this.state.user.uid}/blogs`).off();
    this.state.usersRef.child(this.state.user.uid).off();
  };

  addBlog = () => {
    const {
      blogsRef,
      blogName,
      blogType,
      blogDetails,
      user,
      blogDate,
      usersRef,
    } = this.state;

    const key = usersRef.child(user.uid).child("blogs").push().key;

    const newBlog = {
      id: key,
      type: blogType,
      name: blogName,
      details: blogDetails,
      createdBy: {
        name: user.displayName,
        avatar: user.photoURL,
      },
      timestamp: firebase.database.ServerValue.TIMESTAMP,
      blogDate: blogDate,
    };

    usersRef
      .child(user.uid)
      .child("blogs")
      .child(key)
      .update(newBlog)
      .then(() => {
        this.setState({ blogName: "", blogDetails: "", blogType: "" });
        this.closeModal();
        console.log("blog added");
      })
      .catch((err) => {
        console.error(err);
      });
  };

  blogExistsForTheDate(date) {
    return this.state.blogs.some(
      (blog) => moment(blog.timestamp).format("LL") === date
    );
  }

  getScoreToAdd() {
    let currentMoment = moment(firebase.database.ServerValue.TIMESTAMP);
    let currDate = currentMoment.format("LL");

    //If there is already a blog for today
    if (this.blogExistsForTheDate(currDate)) return 0;
    else {
      currentMoment = currentMoment.subtract(1, "days");
      currDate = currentMoment.format("LL");
      let score = BLOG_ADD_SCORE;
      while (this.blogExistsForTheDate(currDate)) {
        currentMoment = currentMoment.subtract(1, "days");
        currDate = currentMoment.format("LL");
        score += BLOG_ADD_SCORE;
      }
      return score;
    }
  }

  updateUserContributions() {
    let valToAdd = this.getScoreToAdd();

    if (valToAdd === 0) return;

    let currentVal = this.state.userContributions;
    let valToPush = { contributions: currentVal + valToAdd };
    this.state.usersRef
      .child(this.state.user.uid)
      .update(valToPush)
      .then(() => {
        this.setState({ userContributions: currentVal + valToAdd });
        console.log("User contribution updated");
      })
      .catch((err) => {
        console.error(err);
      });
  }

  deleteBlog(blog) {
    this.state.usersRef
      .child(this.state.user.uid)
      .child("blogs")
      .child(blog.uid)
      .remove()
      .then(() => {
        console.log("blog removed");
      })
      .catch((err) => {
        console.error(err);
      });
  }

  handleSubmit = (event) => {
    event.preventDefault();
    if (this.isFormValid(this.state)) {
      this.updateUserContributions();
      this.addBlog();
    }
  };

  handleChange = (event) => {
    this.setState({ [event.target.name]: event.target.value });
  };

  isFormValid = ({ blogName, blogDetails }) => blogName && blogDetails;

  openModal = () => this.setState({ typeModal: true, contentModal: false });

  toggleModal(ind) {
    this.setState({
      typeModal: false,
      contentModal: true,
      channelType: BlogTypesInfo[ind].name,
    });
  }

  closeModal = () => this.setState({ typeModal: false, contentModal: false });

  displayBlogTypes = (blogs) =>
    blogs.length > 0 &&
    blogs.map((chn, ind) => (
      <Grid.Row key={ind} centered="true">
        <Button
          color={chn.color}
          inverted
          onClick={() => this.toggleModal(ind)}
          size="large"
          style={{ width: "50%" }}
        >
          <h1>{chn.name}</h1>
          <h5>{chn.description}</h5>
        </Button>
      </Grid.Row>
    ));

  timeFromNow = (timestamp) => moment(timestamp).fromNow();

  texttohtml = (text) => {
    var html = text;
    var parser = new DOMParser();
    var wrapper = parser.parseFromString(html, "text/html");
    return wrapper;
  };

  createElementFromHTML = (htmlString) => {
    var div = document.createElement("div");
    div.innerHTML = htmlString.trim();

    // Change this to div.childNodes to support multiple top-level nodes
    return div.firstChild;
  };

  handleEditorChange = (content) => {
    this.setState({ blogDetails: content });
  };

  displayBlogs = (blogs) =>
    blogs.length === 0 ? (
      <strong style={{ padding: 5, fontSize: "25", color: "black" }}>
        Start writing your daily diaries here, and get nostalgic after reading
        them later in your life.
      </strong>
    ) : (
      blogs.map((blog) => (
        <Segment color="blue" name={blog.name} details={blog.details}>
          <span>
            <div>
              <Button
                floated="right"
                color="red"
                onClick={() => this.deleteBlog(blog)}
              >
                Delete
              </Button>
            </div>
            <div>
              <Header as="h2">{blog.name}</Header>
            </div>
          </span>
          <Container
            fluid
            style={{
              fontSize: 16,
              marginTop: 15,
              textAlign: "justify",
            }}
          >
            <td>{Parser(blog.details)}</td>
          </Container>
        </Segment>
      ))
    );

  addBlogsIcon() {
    return (
      <React.Fragment>
        <Label onClick={this.openModal} color="green">
          <Icon name="add" /> Write your diary
        </Label>
      </React.Fragment>
    );
  }

  render() {
    const { blogs, contentModal, typeModal } = this.state;

    return (
      <React.Fragment>
        <Header as="h1">
          <span>
            <Icon name="book" color="black" /> {"Your Private Diary"} (
            {blogs.length}) {this.addBlogsIcon()}
          </span>
        </Header>
        <Item.Group divided>{this.displayBlogs(blogs)}</Item.Group>

        {/* Add Channel Content Modal */}
        <Modal basic open={contentModal} onClose={this.closeModal}>
          <Modal.Header>Write your diary.</Modal.Header>
          <Modal.Content>
            <Form onSubmit={this.handleSubmit}>
              <Form.Field>
                <Input
                  fluid
                  label="Date of your diary"
                  name="blogName"
                  placeholder="Date, Month, Year in any format you like"
                  onChange={this.handleChange}
                />
              </Form.Field>

              <Form.Field>
                <Editor
                  value={this.state.blogDetails}
                  initialValue="<p>This is the initial content of the editor</p>"
                  init={{
                    height: 500,
                    menubar: true,
                    plugins: [
                      "advlist autolink lists link image charmap print preview anchor",
                      "searchreplace visualblocks code fullscreen",
                      "insertdatetime paste code help wordcount",
                    ],
                    toolbar:
                      "undo redo | formatselect | bold italic backcolor | \
              alignleft aligncenter alignright alignjustify | \
              bullist numlist outdent indent | removeformat | help",
                  }}
                  onEditorChange={this.handleEditorChange}
                />
                {/* <TextArea
                  style={{ height: 450 }}
                  fluid
                  placeholder="Write about what happened today in brief!!"
                  name="blogDetails"
                  onChange={this.handleChange}
                /> */}
              </Form.Field>
            </Form>
          </Modal.Content>

          <Modal.Actions>
            <Button color="green" inverted onClick={this.handleSubmit}>
              <Icon name="checkmark" /> Add
            </Button>
            <Button color="red" inverted onClick={this.closeModal}>
              <Icon name="remove" /> Cancel
            </Button>
          </Modal.Actions>
        </Modal>

        <Modal basic open={typeModal} onClose={this.closeModal}>
          <Modal.Actions>
            <Grid centred="true">{this.displayBlogTypes(BlogTypesInfo)}</Grid>
          </Modal.Actions>
        </Modal>
      </React.Fragment>
    );
  }
}

const mapStateToProps = (state) => ({
  currentUser: state.user.currentUser,
});

export default connect(mapStateToProps)(Blogs);



// WEBPACK FOOTER //
// ./src/components/SidePanel/Blogs.js